// extracted by mini-css-extract-plugin
export default {"bodyFont":"FileTemplate_bodyFont__dk7pj","linkButton":"FileTemplate_linkButton__Nfydg"};